"use strict";
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
let SearchPage = (() => {
    var _a;
    let _instanceExtraInitializers = [];
    let _setResults_decorators;
    let _setKpiMode_decorators;
    let _setYearMode_decorators;
    let _setCountryMode_decorators;
    let _updateLevel_decorators;
    return _a = class SearchPage {
            constructor() {
                Object.defineProperty(this, "_filters", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (__runInitializers(this, _instanceExtraInitializers), {})
                });
                Object.defineProperty(this, "_selectedFilters", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: {}
                });
                Object.defineProperty(this, "_levels", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: [
                        { key: 'column', value: '' },
                        { key: 'level1', value: '' },
                        { key: 'level2', value: '' },
                        { key: 'level3', value: '' },
                        { key: 'criteria', value: '' },
                        { key: 'topBottom', value: '' },
                        { key: 'hideEmptyValues', value: false },
                        { key: 'isTresholdSeted', value: false },
                        { key: 'treshold', value: ['', ''] },
                    ]
                });
                Object.defineProperty(this, "_results", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: []
                });
                Object.defineProperty(this, "_isSingleKpiMode", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                Object.defineProperty(this, "_isSingleYearMode", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                Object.defineProperty(this, "_isSingleCountryMode", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                Object.defineProperty(this, "_displayedResult", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: []
                });
                Object.defineProperty(this, "_userId", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ''
                });
                Object.defineProperty(this, "locale", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ''
                });
                Object.defineProperty(this, "bearer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ''
                });
                Object.defineProperty(this, "_showStatistics", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: 0
                });
                Object.defineProperty(this, "_currentPage", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: 1
                });
                Object.defineProperty(this, "_columnList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: {
                        statistics: [],
                        typeFieldMap: [],
                        statisticResults: [],
                        criteria: [],
                    }
                });
                (0, mobx_1.makeObservable)(this, {
                    _filters: mobx_1.observable.ref,
                    _selectedFilters: mobx_1.observable.ref,
                    _levels: mobx_1.observable.ref,
                    _results: mobx_1.observable.ref,
                    _isSingleKpiMode: mobx_1.observable.ref,
                    _isSingleCountryMode: mobx_1.observable.ref,
                    _isSingleYearMode: mobx_1.observable.ref,
                    _displayedResult: mobx_1.observable.ref,
                    _userId: mobx_1.observable.ref,
                    _showStatistics: mobx_1.observable.ref,
                    _currentPage: mobx_1.observable.ref,
                    _columnList: mobx_1.observable.ref,
                    filters: mobx_1.computed,
                    selectedFilters: mobx_1.computed,
                    levels: mobx_1.computed,
                    results: mobx_1.computed,
                    displayedResult: mobx_1.computed,
                    userId: mobx_1.computed,
                    showStatistics: mobx_1.computed,
                    currentPage: mobx_1.computed,
                    columnList: mobx_1.computed,
                    getLevelValue: mobx_1.action,
                    setResults: mobx_1.action,
                    updateLevel: mobx_1.action,
                });
            }
            get filters() {
                return this._filters;
            }
            set filters(value) {
                this._filters = value;
            }
            get selectedFilters() {
                return this._selectedFilters;
            }
            set selectedFilters(value) {
                this._selectedFilters = value;
            }
            getLevelValue(levelKey) {
                const level = this._levels.find(l => l.key === levelKey);
                return level ? level.value : null;
            }
            get levels() {
                return this._levels;
            }
            get userId() {
                return this._userId;
            }
            set userId(value) {
                this._userId = value;
            }
            get showStatistics() {
                return this._showStatistics;
            }
            set showStatistics(value) {
                this._showStatistics = value;
            }
            get results() {
                return this._results;
            }
            get isSingleKpiMode() {
                return this._isSingleKpiMode;
            }
            get displayedResult() {
                return this._displayedResult;
            }
            set displayedResult(value) {
                this._displayedResult = value;
            }
            get currentPage() {
                return this._currentPage;
            }
            set currentPage(value) {
                this._currentPage = value;
            }
            get columnList() {
                return this._columnList;
            }
            set columnList(value) {
                this._columnList = value;
            }
            setResults(data) {
                this._results = data;
            }
            setKpiMode(info) {
                this._isSingleKpiMode = info;
            }
            setYearMode(info) {
                this._isSingleYearMode = info;
            }
            setCountryMode(info) {
                this._isSingleCountryMode = info;
            }
            updateLevel(levelKey, newValue) {
                this._levels = this._levels.map(level => level.key === levelKey ? Object.assign(Object.assign({}, level), { value: newValue }) : level);
            }
        },
        (() => {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _setResults_decorators = [mobx_1.action];
            _setKpiMode_decorators = [mobx_1.action];
            _setYearMode_decorators = [mobx_1.action];
            _setCountryMode_decorators = [mobx_1.action];
            _updateLevel_decorators = [mobx_1.action];
            __esDecorate(_a, null, _setResults_decorators, { kind: "method", name: "setResults", static: false, private: false, access: { has: obj => "setResults" in obj, get: obj => obj.setResults }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _setKpiMode_decorators, { kind: "method", name: "setKpiMode", static: false, private: false, access: { has: obj => "setKpiMode" in obj, get: obj => obj.setKpiMode }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _setYearMode_decorators, { kind: "method", name: "setYearMode", static: false, private: false, access: { has: obj => "setYearMode" in obj, get: obj => obj.setYearMode }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _setCountryMode_decorators, { kind: "method", name: "setCountryMode", static: false, private: false, access: { has: obj => "setCountryMode" in obj, get: obj => obj.setCountryMode }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _updateLevel_decorators, { kind: "method", name: "updateLevel", static: false, private: false, access: { has: obj => "updateLevel" in obj, get: obj => obj.updateLevel }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
const searchPageStore = new SearchPage();
exports.default = searchPageStore;
(0, mobx_1.autorun)(() => {
    // console.log(searchPageStore.filters);
    // console.log(searchPageStore.selectedFilters);
    // console.log(searchPageStore.levels);
    // console.log(searchPageStore.currentPage);
});
